import { Link } from 'react-router-dom';
import { FaHeart, FaLink, FaInfoCircle, FaRocket } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-50 to-indigo-50 border-t border-blue-100 py-4">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center text-center">
          {/* 版权信息 */}
          <div className="mb-3">
            <p className="text-gray-600 text-sm flex items-center justify-center">
              <FaHeart className="text-pink-500 mr-2" /> 
              {new Date().getFullYear()} 装个机 ZhuangIt
            </p>
          </div>
          
          {/* 快速链接 */}
          <div className="flex space-x-6 text-xs">
            <Link to="/about" className="text-primary hover:text-blue-700 transition-colors flex items-center">
              <FaInfoCircle className="mr-1" />
              关于我们
            </Link>
            <a href="https://jianpanzhushou.ababtools.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-blue-700 transition-colors flex items-center">
              <FaLink className="mr-1" />
              键盘学习助手
            </a>
            <a href="https://ababtools.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-blue-700 transition-colors flex items-center">
              <FaRocket className="mr-1" />
              实用软件工具
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;